import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["innerHTML"]

import { useGame, useBase, useModal } from '@/store';
import { storeToRefs } from 'pinia';
import BaseModal from '@ui/components/Modal/BaseModal.vue';
import ButtonConfirm from '@ui/components/Modal/components/ButtonConfirm.vue';
import ButtonClose from '@ui/components/Modal/components/ButtonClose.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorMsg',
  setup(__props) {

const { login, logout } = useGame();
const { errorMsg } = storeToRefs(useBase());
const { closeModal } = useModal();

const NEED_LOGIN_ERROR = ['ERROR__LOGIN_FIRST'];
const NEED_LOGOUT_ERROR = [
  'ERROR__BAD_REQUEST',
  'ERROR__GAME_LOGIN_FAILED',
  'ERROR__GOP_LOGIN_FAILED',
  'ERROR__NO_CHARACTER',
];

function clickToConfirm() {
  if (NEED_LOGIN_ERROR.includes(errorMsg.value)) {
    login();
  } else if (NEED_LOGOUT_ERROR.includes(errorMsg.value)) {
    logout();
  } else {
    closeModal();
  }
}
function clickToClose() {
  if (NEED_LOGOUT_ERROR.includes(errorMsg.value)) {
    logout();
  } else {
    closeModal();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    base: true,
    class: "error_msg"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('MODAL__ALERT_MSG__TITLE')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "wrap",
          innerHTML: _ctx.$t(_unref(errorMsg))
        }, null, 8, _hoisted_3)
      ]),
      _createVNode(ButtonConfirm, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (clickToConfirm()))
      }),
      _createVNode(ButtonClose, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (clickToClose()))
      })
    ]),
    _: 1
  }))
}
}

})